import React from 'react';

export default function() {
  return <p>
    We're sorry, the page you requested could not be found. If you require
    further assistance please contact us directly by submitting a ticket{' '}
    <a href="https://desk.zoho.com/portal/berkeleypayment/home">here</a>
  </p>;
};
